// src/hooks/useAutoLogout.js
import { useEffect, useRef } from "react";

const useAutoLogout = (onLogout, timeoutMs = 3 * 60 * 60 * 1000) => {
  const timer = useRef(null);

  const resetTimer = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      onLogout();
    }, timeoutMs);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    const handleActivity = () => resetTimer();

    for (const event of events) {
      window.addEventListener(event, handleActivity);
    }

    resetTimer(); // Initialize the timer

    return () => {
      clearTimeout(timer.current);
      for (const event of events) {
        window.removeEventListener(event, handleActivity);
      }
    };
  }, []);
};

export default useAutoLogout;
